<!--  Navbar Starts  -->

<div class="header-container fixed-top">
  <header style="position: fixed; left: 93%;" class="header navbar navbar-expand-sm">
    <ul class="navbar-item flex-row ml-md-auto">
      <li class="nav-item dropdown language-dropdown">
        <a
          href="javascript:void(0);"
          class="nav-link dropdown-toggle"
          id="language-dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <img [src]="currentLanguageImage" class="flag-width" alt="flag" />
        </a>
        <div
          class="dropdown-menu position-absolute"
          aria-labelledby="language-dropdown"
        >
          <a
            class="dropdown-item d-flex"
            (click)="changeSiteLanguage('en')"
            href="javascript:void(0);"
          >
            <img
              src="assets/img/flag/usa-flag.png"
              class="flag-width"
              alt="flag"
            />
            <span class="align-self-center"
              >&nbsp;{{ 'header.english' | translate }}</span
            >
          </a>
          <a
            class="dropdown-item d-flex"
            (click)="changeSiteLanguage('es')"
            href="javascript:void(0);"
          >
            <img
              src="assets/img/flag/spain-flag.png"
              class="flag-width"
              alt="flag"
            />
            <span class="align-self-center"
              >&nbsp;{{ 'header.spanish' | translate }}</span
            >
          </a>
        </div>
      </li>
    </ul>
  </header>
</div>
<router-outlet></router-outlet>
